import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
import translationFr from "zod-i18n-map/locales/fr/zod.json";
import translationEn from "zod-i18n-map/locales/en/zod.json";

import fr from "../locales/fr.json";
import en from "../locales/en.json";

const resources = {
  fr: {
    translation: fr,
    zod: translationFr,
  },
  en: {
    translation: en,
    zod: translationEn,
  },
};

z.setErrorMap(zodI18nMap);

i18n.use(initReactI18next).init({
  resources,
  supportedLngs: ["fr", "en"],
  fallbackLng: "fr",
  lng: "fr",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
